module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.3fac9d47.woff2";